import { observable, action, computed, decorate } from 'mobx';

class SetupStore {
  constructor({ pubSub }) {
    this.data = undefined;
    this.loading = undefined;
    this.error = undefined;

    this.subscribeToActions(pubSub);
  }

  subscribeToActions({ subscribe, TOPICS }) {
    subscribe(TOPICS.CHANGE_LOADING_STATUS, (msg, data) => {
      this.setLoadingStatus(data);
    });

    subscribe(TOPICS.CHANGE_ERROR_STATUS, (msg, data) => {
      this.setErrorStatus(data);
    });
  }

  get isActionButtonVisible() {
    return !this.loading;
  }

  setLoadingStatus = (loading) => (this.loading = loading);

  setErrorStatus = (error) => (this.error = error);

  setData = (data) => (this.data = data);

  preload = (callback) => {
    if (typeof callback !== 'function') {
      throw new Error(`preLoad must be a function ${typeof callback} provided`);
    }

    this.setLoadingStatus(true);

    return callback()
      .then((data) => {
        this.setData(data);
        this.setLoadingStatus(false);
      })
      .catch((error) => {
        this.setErrorStatus(error);
        this.setLoadingStatus(false);
      });
  };

  action(callback) {
    if (typeof callback !== 'function') {
      throw new Error(`Action must be a function ${typeof callback} provided`);
    }
    callback(this.data);
  }
}

export default decorate(SetupStore, {
  data: observable,
  loading: observable,
  error: observable,
  isActionButtonVisible: computed,
  setLoadingStatus: action,
  setErrorStatus: action,
  setData: action,
});
